import { IAssessmentDetails } from "@Models/IAssessmentDetails";
import { IFeedbackTemplateDetails } from "@Models/IFeedbackTemplateDetails";
import moment from "moment";

const BLANK_ITEM = { id: "0" } as const;

const BLANK_TEMPLATE: IFeedbackTemplateDetails = {
  templateId: "",
  groupId: "",
  name: "New Template",
  description: "New template description",
  locked: false,
  fields: [
    {
      id: "0",
      name: "New field",
      type: "text",
      defaultValue: "New field",
      options: [],
    },
  ],
};

const INITIAL_VALUES: IAssessmentDetails = {
  assessmentId: null,
  description: null,
  endDate: null,
  lateSubmissions: 0,
  name: null,
  owner: null,
  startDate: moment() as never, // moment is required here before the DatePicker uses moment. DatePicker converts this value into a string
};

const INITIAL_TASK_VALUES = {
  activityId: null,
  assessmentInstanceId: "",
  automated: false,
  institutional: false,
  quantity: 1,
  recorded: false,
};

enum ActivityCheckboxTooltip {
  Automated = "Automated tasks are preselected",
  Capacity = "Deselect an activity to select more",
  Recorded = "You must select a recorded activity",
}

enum AssessorTooltip {
    SelectFirst = "Please select an Assessor first.",
}

enum DisabledFieldsTooltip {
    PastEndDate = "cannot be modified after the end date.",
    PastStartDate = "cannot be modified after the start date.",
    PastSubmissionDate = "Late submission allowance cannot be modified after the end date and late submission allowance.",
}

enum TaskTooltip {
    Automated = "Should this task use the first attempts made for submission, rather than letting the user select from a range of their completed activities? This is useful for examination conditions.",
    Institutional = "Does this task require an Inovus institutional device? (e.g. a trolley system instead of a take-home simulator.)",
    Recorded = "Does this task need to be recorded? If yes, the user must enable recording for their activity to be admissible.",
}

export {
    BLANK_ITEM,
    BLANK_TEMPLATE,
    INITIAL_TASK_VALUES,
    INITIAL_VALUES,
    ActivityCheckboxTooltip,
    AssessorTooltip,
    DisabledFieldsTooltip,
    TaskTooltip,
};
